import { AuthConfigIds } from '../../auth/auth.config';

export interface AuthState {
  idp: AuthConfigIds | null;
  checkingAuth: boolean;
}

export const authInitialState: AuthState = {
  idp: null,
  checkingAuth: false,
};
